import React from 'react';
import { Box, Card, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

/**
 * Generic summary card used by the Key Insights section.
 * Purely presentational - all values are passed in as props so it can be
 * reused for any future metric card without modification.
 */
const KeyInsightCard = ({
  icon,
  paletteColor = 'primary',
  label,
  value,
  valueSuffix = '',
  percentageLabel,
  subtitle,
}) => {
  return (
    <Card
      variant="outlined"
      sx={{
        p: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box
          sx={(theme) => ({
            width: 40,
            height: 40,
            borderRadius: `${theme.shape.borderRadius}px`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            bgcolor: alpha(theme.palette[paletteColor].main, 0.12),
            color: theme.palette[paletteColor].main,
            '& svg': { fontSize: 20 },
          })}
        >
          {icon}
        </Box>
        <Typography variant="body2" color="text.secondary" fontWeight={500}>
          {label}
        </Typography>
      </Stack>

      <Stack direction="row" spacing={0.75} alignItems="baseline">
        <Typography variant="h4" fontWeight={600} color="text.primary">
          {value !== undefined && value !== null ? `${value}${valueSuffix}` : '--'}
        </Typography>
        {percentageLabel && (
          <Typography variant="body2" color="text.secondary">
            ({percentageLabel})
          </Typography>
        )}
      </Stack>

      {subtitle && (
        <Typography variant="caption" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Card>
  );
};

export default KeyInsightCard;